import "../../stylesheets/App.css";
import "../../stylesheets/PopupRegister.css";
import React from "react";

function Loader() {
  return (
    <>
      <div className="popup-register-container loader-full-container">
        <div className="loader-container">
          <img
            className="intro-loader"
            src={process.env.PUBLIC_URL + "/images/intro/Loader.png"}
            alt="Cargando..."
          />
        </div>
      </div>
    </>
  );
}

export default Loader;
